var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVermittlungPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1711.67 499.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #624694;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #5f8f11;\n      }\n\n      .cls-3 {\n        fill: #44abed;\n      }\n\n      .cls-4 {\n        fill: #788089;\n      }\n\n      .cls-5 {\n        fill: #524759;\n      }\n\n      .cls-6 {\n        fill: #8364db;\n      }\n\n      .cls-7 {\n        fill: #7b56ba;\n      }\n\n      .cls-8 {\n        fill: #2b3983;\n      }\n\n      .cls-9 {\n        fill: #2c2334;\n      }\n\n      .cls-10 {\n        fill: #6d4ea6;\n      }\n\n      .cls-11 {\n        fill: #894545;\n      }\n\n      .cls-12 {\n        fill: #965a5f;\n      }\n\n      .cls-13 {\n        fill: #726b80;\n      }\n\n      .cls-14 {\n        fill: #3c2534;\n      }\n\n      .cls-15 {\n        fill: #3d8ead;\n      }\n\n      .cls-16 {\n        fill: #412233;\n      }\n\n      .cls-17 {\n        fill: #233559;\n      }\n\n      .cls-18 {\n        fill: #cc8076;\n      }\n\n      .cls-19 {\n        fill: #c9b8c2;\n      }\n\n      .cls-20 {\n        fill: #db8f7f;\n      }\n\n      .cls-21 {\n        fill: #b2695d;\n      }\n\n      .cls-22 {\n        fill: #a8636a;\n      }\n\n      .cls-23 {\n        fill: #ba403b;\n      }\n\n      .cls-24 {\n        fill: #73617a;\n      }\n\n      .cls-25 {\n        fill: #ba8a80;\n      }\n\n      .cls-26 {\n        fill: #9a5c51;\n      }\n\n      .cls-27 {\n        fill: #ff9573;\n      }\n\n      .cls-28 {\n        fill: #ff8252;\n      }\n\n      .cls-29 {\n        fill: #e54f49;\n      }\n\n      .cls-30 {\n        fill: #fff;\n      }\n\n      .cls-31 {\n        fill: #eeba80;\n      }\n\n      .cls-32 {\n        fill: #ea6;\n      }\n\n      .cls-33 {\n        fill: #ffdace;\n      }\n\n      .cls-34 {\n        fill: #ea9574;\n      }\n\n      .cls-35 {\n        fill: #eec895;\n      }\n\n      .cls-36 {\n        fill: #edd5ca;\n      }\n\n      .cls-37 {\n        fill: #ffba78;\n      }\n\n      .cls-38 {\n        fill: #e89364;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "483.29 499.83 486.02 468.83 297.43 468.83 298.32 499.83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m486.02,229.48v239.35H217.07v-239.35c0-21.83,8.34-41.74,22.05-56.65,9.22-10.1,20.9-17.93,34.07-22.55,8.71-3.05,18.06-4.7,27.79-4.7h101.14c13.84,0,26.91,3.34,38.4,9.27,20.71,10.69,36.37,29.71,42.6,52.62,1.9,7.03,2.91,14.4,2.91,22.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "387.58 162.25 381.21 188.28 398.46 200.14 398.4 434.58 424.64 475.62 447.97 439.1 403.14 198.63 406.39 185.48 387.58 162.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "346.64 181.83 410.15 356.22 433.7 181.83 455.33 250.24 463.44 468.83 351.54 468.83 346.64 181.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "446.05 468.83 416.4 430.37 381.21 468.83 446.05 468.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m412.26,398.86c0,2.94,2.38,5.32,5.32,5.32s5.32-2.38,5.32-5.32-2.38-5.32-5.32-5.32-5.32,2.38-5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "393.88 168.04 349.07 132.08 366.29 71.9 416.79 83.44 393.88 168.04"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 392.43,
    cy: 77.23,
    r: 31.32,
    transform: "translate(70.36 314.38) rotate(-47.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 395.64,
    cy: 119.97,
    rx: 21.15,
    ry: 13.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m406.9,126.83l-22.36-4.91-2.12-46.32,41.33,2.08.1,35.41c.12,8.61-8.5,15.6-16.95,13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m407.1,102.14h21.39v5.15c0,1.88-1.53,3.41-3.41,3.41h-14.57c-1.88,0-3.41-1.53-3.41-3.41v-5.15h0Z",
    transform: "translate(835.59 212.84) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 359.7,
    y: 63.48,
    width: 32.5,
    height: 26.11,
    rx: 5.07,
    ry: 5.07,
    transform: "translate(751.9 153.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m428.29,101.18c2.73,0,5.14-4.42,5.6-10.29.48-6.05-1.35-11.03-4.16-11.32h-.26c-2.73-.01-5.14,4.41-5.61,10.27-.48,6.05,1.35,11.02,4.16,11.32l.26.02Zm1.18-19.83c1.76.18,3.29,4.07,2.87,9.38-.41,5.18-2.43,8.66-4.05,8.66h-.12c-1.64-.18-3.17-4.07-2.75-9.38.41-5.18,2.43-8.66,4.06-8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m412.15,100.96c4.01,0,7.52-4.5,7.97-10.25.48-6.08-2.57-11.38-6.8-11.82-4.26-.42-8.06,4.21-8.54,10.22-.48,6.08,2.57,11.38,6.8,11.82.19.02.38.03.57.03Zm.61-19.86c.13,0,.26,0,.39.02,3.15.33,5.41,4.54,5.02,9.38-.38,4.8-3.22,8.49-6.42,8.19-3.15-.33-5.41-4.54-5.02-9.38.36-4.6,3.01-8.21,6.02-8.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 419.18,
    y: 88.8,
    width: 5.46,
    height: 2.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "381.55 87.82 405.62 89.03 406.21 86.87 381.76 85.51 381.55 87.82"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "382.42 88.72 356.71 103.92 359.7 73.28 382.42 88.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m385.68,90.64c-1.13,5.14-6.21,8.39-11.35,7.26-5.14-1.13-8.39-6.21-7.26-11.35,1.13-5.14,6.21-8.39,11.35-7.26,5.14,1.13,8.39,6.21,7.26,11.35Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "218.99 499.83 219.79 468.83 406.01 468.83 401.77 499.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "238.01 499.83 238.65 468.83 244.02 468.83 243.38 499.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m198.5,499.83l9.72-173.74,5.42-96.7c1.93-46.85,40.47-83.82,87.36-83.82,0,0,.6.25,1.64.72,1.85.85,5.15,2.48,9.3,5.09,1.6,1,3.33,2.14,5.15,3.44,19.24,13.67,48.8,44.23,48.23,102.5-.19,19.93-.29,45.11-.35,72.04v10.38c-.02,6.16-.02,12.36-.02,18.6,0,30.56.04,85,.1,141.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 233.69,
    y: 414.42,
    width: 69.12,
    height: 5.13
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "422.75 102.13 418.41 102.13 418.41 100.59 421.21 100.59 421.21 95.27 422.75 95.27 422.75 102.13"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m452.31,499.83v-195.85c0-68-12.43-107.22-25.33-129.62-4.61-7.99-9.29-13.85-13.48-18.1-5.31-5.41-9.86-8.24-12.51-9.6-1.59-.8-2.5-1.1-2.5-1.1.35,0,.71,0,1.08.02.39,0,1.04-.92,1.42-.89,88.44,1.39,89.68,87.28,89.68,87.28,2.88,31.35,3.2,155.56,2.85,267.84"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m399.56,145.6l1.42,1.08c-1.59-.8-2.5-1.1-2.5-1.1.35,0,.71,0,1.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m452.3,317.49l24.41-77.61-31.76-25.62,12.06-16.86-30.04-23.02c-4.61-7.99-9.29-13.85-13.48-18.1l52,39.85-12.14,16.99,30.5,24.61-31.55,100.31v-20.53Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "344.72 128.64 388.87 161.56 381.21 188.28 332.68 145.57 344.72 128.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "400.98 141.81 387.58 162.25 406.39 185.48 410.15 149.61 400.98 141.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m364.95,329.39v10.38l-54.23-73.6,35.53-40.9-59.46-27.23,25.13-46.64c1.6,1,3.33,2.14,5.15,3.44l-21.72,40.33,60.95,27.92-37.69,43.4,46.33,62.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m201.7,357.68l110.55-23.77-38.22-181.57c-107.51,47.29-72.33,205.33-72.33,205.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "385.01 265.99 327.1 263.89 337.59 284.14 385.01 265.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m276.26,299.81c12.64,21.44,33.84,32.54,49.61,25.07,17.11-8.13,21.3-35.21,9.3-60.42-10.14-21.41-26.76-26.16-42.04-22.15l11.44,51.16s-13.98,3.17-28.31,6.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "201.78 441.3 322.53 371.98 205.75 370.19 201.78 441.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "493.62 430.37 422.9 377.99 493.62 404.18 493.62 430.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m464.24,169.81s65.69,46.1,77.99,176.8l-89.17-22.49,16.96-118.05-5.78-36.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "505.58 300.86 522.89 307.75 495.28 279.18 505.58 300.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "455.75 308.1 469.03 223.35 465.06 222.66 451.78 307.4 455.75 308.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 459.05,
    cy: 308.93,
    rx: 46.76,
    ry: 60.58,
    transform: "translate(-82.34 423.21) rotate(-45.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m326.41,282.88s8.15.36,21.08,1.07c39.31,2.14,122.65,7.5,153.84,15.64,34.03,8.88,46.43,37.23,38.85,66.26-1.07,4.12-2.6,8.03-4.49,11.64-11.44,21.74-36.67,33.6-61.48,27.28-.09-.02-.2-.05-.29-.08l-165.38-53.23,17.87-68.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 297.14,
    y: 219.86,
    width: 4.02,
    height: 98.63,
    transform: "translate(-45.81 61.93) rotate(-10.98)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m453.76,292.11s-155.92,100.17-187.42,107.04c-34.37,7.49-58.26-12.16-64.64-41.48-.92-4.16-1.32-8.33-1.26-12.41.35-24.56,17.47-46.56,42.45-52.17.09-.02.2-.04.29-.06l185.08-35.29h0c13.53,3.85,23.39,15.5,24.96,29.49l.55,4.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "435.31 300.87 340.41 361.73 369.77 371.18 435.31 300.87"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m834.19,470.59l-67.49,26.41c-5.67,2.22-12.09-.85-13.81-6.81-.19-.62-.29-1.25-.34-1.89-.21-2.51.58-4.98,2.07-6.99,1.23-1.65,2.91-2.98,4.9-3.76,2.38-.94,2.92-4.08.94-5.72l-29.72-25.08s-.03-.02-.08-.05l-3.25-2.77,7.91-9.31,33.96-40.02,3.02,2.55,13.98,11.8s11.23,9.47,17.95,15.15l4.57,3.86,10.39,8.76c23.67,19.48,20.02,31.87,15,33.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m772.58,397.43l-33.13,39.05-8.71,10.28s-.03-.02-.08-.05c-.64-.35-83.86-33.24-107.37-53.05-24.55-20.74-23.54-48.92-5.84-69.79,8.86-10.45,21.17-16.33,33.85-17.37,12.63-1.03,25.68,2.74,36.14,11.56,0,0,20.2,19.1,20.23,19.12l64.64,59.99.29.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "706.57 441.11 521.5 441.11 518.42 499.83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m706.59,207.16v233.96h-263.97v-233.96c0-21.34,8.21-40.81,21.66-55.39,7.59-8.29,16.89-15,27.34-19.6,1.97-.9,4.01-1.71,6.08-2.43.5-.18,1.01-.34,1.51-.52,8.11-2.66,16.79-4.08,25.77-4.08h99.26c13.58,0,26.4,3.26,37.68,9.04,6.36,3.27,12.22,7.34,17.47,12.05,11.55,10.4,20.12,24,24.32,39.38,1.88,6.88,2.89,14.08,2.89,21.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "442.62 412.87 479.2 392.26 442.62 382.04 442.62 412.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m554.37,210.11l-51.7,144.97c-10.03,29.12-41.88,44.63-71.11,34.63-29.23-9.99-44.82-41.7-34.77-70.83l51.67-144.96c3.74-10.84,10.47-19.81,18.99-26.26.63-.47,1.26-.94,1.91-1.39,14.16-9.82,32.66-12.98,50.2-7.01,29.25,10.01,44.84,41.72,34.81,70.84Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "439.38 499.83 445.3 441.11 628.06 441.11 616.32 499.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "458.16 499.84 463.81 441.11 469.09 441.11 463.43 499.83"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "609.97 120.01 601.67 148.7 622.86 174.75 627.1 134.51 609.97 120.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "601.87 151.24 562.85 118.85 586.45 60.96 625.06 69.4 601.87 151.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m640.85,63.63c-2.55,4.96-11.82,5.31-20.71.79-8.89-4.53-14.04-12.22-11.49-17.18,2.55-4.96,11.82-5.31,20.71-.79,8.89,4.53,14.04,12.22,11.49,17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m636.62,65.98v.97c-.02,1.59-.22,3.22-.58,4.85-2.84,12.77-14.9,21.14-27.65,19.71-.86-.1-1.72-.26-2.58-.44-1.42-.32-2.8-.74-4.09-1.27-11.28-4.53-17.95-16.63-15.25-28.86,2.99-13.62,16.53-22.25,30.23-19.27,3.05.68,5.87,1.87,8.37,3.48l1.32.91.2.14c6.13,4.64,9.89,11.92,10.01,19.77h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m636.72,96.76c0,.3,0,.6-.04.88-.46,7.1-7.69,12.63-14.76,11.08l-19.53-4.26-.68-14.66-1.18-25.63,3.63.18,32.45,1.63v.97l.1,29.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m630.55,97.49c-5.02.5-8.84-3.71-9-3.89l1.19-1.05c.08.07,3.49,3.81,7.65,3.37l.16,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m636.33,61.42l-30.11-9.74,10.64,9.74c-7.96-.11-8.49,12.31-18.41,16.62-8.18,3.56-17.18,2.85-20.01,2.57l8.01-19.65c3.01-13.64,16.54-22.28,30.23-19.28,10.12,2.21,17.67,10.22,19.65,19.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "614.38 107.08 599.29 103.77 611.99 115.53 614.38 107.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m604.26,78.43c-.99,4.47-5.42,7.3-9.91,6.32-4.49-.98-7.33-5.4-6.34-9.87.99-4.47,5.42-7.3,9.91-6.32,4.49.98,7.33,5.4,6.34,9.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "630.09 88.86 633.89 88.86 633.89 81.7 632.54 81.7 632.54 87.52 630.09 87.52 630.09 88.86"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "562.34 114.67 607.48 149.54 598.84 179.52 548.77 133.68 562.34 114.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 526.13,
    cy: 160.05,
    rx: 27.77,
    ry: 27.66
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m554.68,160.68v17.41c0,9.87-8.03,16.57-17.94,16.57h-5.98c-12.22,0-22.12-8.57-22.12-20.74v-13.24c0-12.08,10.3-21.89,23.01-21.89,6.36,0,12.12,2.46,16.28,6.41,4.16,3.96,6.74,9.43,6.74,15.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m551.53,181.95c1.29,5.32-3.4,10-8.75,8.71-2.51-.6-4.57-2.65-5.18-5.16-1.29-5.32,3.4-10,8.75-8.71,2.51.6,4.57,2.65,5.18,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m511.91,162.88h0c7.4,0,13.4-5.98,13.4-13.35v-2.51c0-2.77-2.26-5.02-5.04-5.02h-8.36c-2.78,0-5.04,2.25-5.04,5.02v10.84c0,2.77,2.26,5.02,5.04,5.02Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 505.59,
    cy: 169.72,
    rx: 10.5,
    ry: 10.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m545.66,175.53c.27,0,.57-.12.81-.34.28-.27.41-.64.37-1.02v-1.33s-1.08,0-1.08,0l-.04,1.58h-.04s-.16.03-.16.03h-2.56s0,1.1,0,1.1h2.56s.1,0,.15,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m521.25,137.57h20.51v6.98h-24.41v-3.08c0-2.15,1.75-3.9,3.9-3.9Z",
    transform: "translate(1059.11 282.12) rotate(-180)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 546.52,
    cy: 183.73,
    rx: 5.57,
    ry: 5.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m554.68,184.03c0,1.09-2.05,1.98-4.58,1.98s-4.58-.89-4.58-1.98,2.05-1.98,4.58-1.98,4.58.89,4.58,1.98Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m511.22,294.23c-12.66,5.73-40.57,6.32-44.17-15.9-2.9-23.96,19.02-97.96,52.67-93.13,27.77,3.98,23.79,16.25,20.68,35.56-2.49,15.04-2.49,30.44,0,45.48,3.11,19.32-16.51,22.26-29.17,28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "541.26 215.49 529.9 212.2 540.06 222.82 541.26 215.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m595.96,213.15c-.24.09-2.09.81-5.14,1.71-5.55,1.63-15.07,3.84-25.97,3.84-3.58,0-7.32-.23-11.11-.81-25.1-3.8-35.57-10.85-37.43-12.23l13.19-17.55c1.37.81,9.48,5.37,27.55,8.11,12.5,1.89,24.69-1.42,29.08-2.83,1.08-.36,1.68-.58,1.71-.59,5.64-2.24,12.04.5,14.29,6.14,2.23,5.62-.52,11.99-6.18,14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m566.35,199.35c-.61.82-1.23,1.65-1.84,2.47-.61.81.76,1.59,1.36.79.61-.82,1.23-1.65,1.84-2.47.61-.81-.76-1.59-1.36-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m567.37,202.14c-.93,1.3-1.9,2.56-2.93,3.77-.65.77.46,1.88,1.11,1.11,1.11-1.32,2.17-2.68,3.18-4.09.59-.83-.78-1.61-1.36-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m595.96,213.15c-.24.09-2.09.81-5.14,1.71.22-.33,2.8-4.27,3.18-11.54.38-7.33-7.37-9.8-7.86-9.94,1.08-.36,1.68-.58,1.71-.59,5.64-2.24,12.04.5,14.29,6.14,2.23,5.62-.52,11.99-6.18,14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m551.96,363.1c-1.08,0-2.18-.11-3.27-.33-8.94-1.79-14.72-10.46-12.92-19.36l7.21-35.7-29.44-18.97c-7.65-4.93-9.84-15.11-4.89-22.73,4.95-7.62,15.17-9.8,22.82-4.87l30.5,19.65c10.82,6.97,16.16,19.6,13.62,32.18l-7.46,36.93c-1.58,7.81-8.46,13.2-16.16,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m549.78,299.8c-2.31,1.78-4.18,4.01-5.55,6.57-.48.89.88,1.68,1.36.79,1.32-2.46,3.1-4.55,5.31-6.26.8-.62-.32-1.72-1.11-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m552.85,302.04c-1.66.64-3.13,1.59-4.34,2.89-.69.74.42,1.85,1.11,1.11,1.02-1.09,2.24-1.95,3.65-2.48.94-.36.53-1.87-.42-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m475.99,362.87h0c-7.35-3.51-10.88-11.93-8.23-19.6,2.06-5.97,4.1-14.44,5.23-26.17,1.63-16.83-3.45-26.49-3.51-26.58-5.32-7.37-3.62-17.65,3.78-22.94,7.4-5.29,17.72-3.61,23.03,3.77,1.47,2.03,14.17,20.73,9.29,50.97-2.27,14.09-4.82,23.84-7.57,31.59-3.16,8.92-13.46,13.05-22.02,8.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m480.98,312.09c-1.29.12-2.56.32-3.82.6-.98.22-.75,1.77.24,1.55,1.26-.28,2.53-.48,3.82-.6,1.01-.09.77-1.64-.24-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m481.75,315.3c-1.86-.17-3.71-.1-5.54.23-1,.18-.76,1.73.24,1.55,1.7-.3,3.4-.38,5.12-.22,1.01.09,1.19-1.46.19-1.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "506.19 295.96 490.49 301.88 506.48 303.01 506.19 295.96"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m541.07,251.36l15.21,65.58c1.28,5.49-2.5,10.92-8.35,11.61-4.14.49-7.99-1.8-9.9-5.33-.43-.8-.76-1.65-.97-2.56-.54-2.32-3.41-3.27-5.24-1.71l-26.98,22.92-2.84,2.42-.96.81-40.26-45.48,9.32-7.92,3.02-2.57,3.49-2.97s18.26-15.49,20.97-17.83l9.68-8.21c21.59-18.8,32.69-13.65,33.82-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m469.09,295.96s-80.52,15.73-69.41,56.28c11.11,40.55,47.2,53.92,79.53,40.02,32.33-13.9,26.49-65.31,26.49-65.31l-36.61-31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "1104.2 499.9 1039.89 415.74 1227.92 415.74 1282.41 499.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "1008.16 499.9 1004.85 415.75 1160.88 415.75 1156.84 499.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m1401.63,304.46l-47.74,13.82-16.87-58.33,20.06-5.79,9.11-21.68c1.84-4.43,5.61-7.77,10.22-9.12l10.33-2.99c4.09-1.18,8.37,1.36,9.18,5.65.7,3.72-1.79,7.33-5.43,8.38l-7.34,2.13c-.75.21-1.43.53-2.06.95-1.15.78-2.08,1.88-2.61,3.2-.35.81-.42,1.61-.3,2.38v.03c.43,2.34,2.8,4.13,5.44,3.38l12.25-3.55c7.52-2.19,13.57-7.6,16.62-14.58v-.03c.89-2.02,1.53-4.16,1.88-6.39.38-2.39,2.06-4.35,4.38-5.02,4.31-1.26,8.47,2.4,7.78,6.85l-9.81,63.55c-1.27,8.17-7.15,14.86-15.09,17.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m1360.31,325.73s-15.68,6.91-36.91,15.95c-33.27,14.16-80.15,33.53-101.65,39.75-28.94,8.37-50.48-7.08-57.61-31.76-5.77-19.89,2.35-40.51,18.65-51.51,3.92-2.64,8.31-4.73,13.1-6.11l1.5-.35,143.57-32.87,19.35,66.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m1380.9,294.65c-25.64,10.52-3.28-50.05-2.71-51.55.43,2.34,2.81,4.13,5.44,3.38l12.25-3.55c7.52-2.19,13.57-7.6,16.62-14.58-.16,1.6-6.01,55.81-31.6,66.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m1407.32,289.7h0c-7.82-.93-13.4-8.03-12.46-15.85l6.97-58.3c.93-7.82,8.03-13.4,15.85-12.46h0c7.82.93,13.4,8.03,12.46,15.85l-6.97,58.3c-.93,7.82-8.03,13.4-15.85,12.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m1088.05,213.14l-5.84,9.15-51.48,80.58-10.14,15.87-44.92,70.32c-15.74,24.82-48.65,32.18-73.47,16.44-24.82-15.74-32.2-48.64-16.44-73.47l41.76-65.4,66.65-104.29,3.97-6.22c5.86-9.24,14.08-16.08,23.4-20.19.69-.3,1.38-.59,2.07-.87,15.28-5.99,33.09-4.83,47.99,4.6,24.83,15.77,32.21,48.67,16.47,73.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m1240.74,201.58v217.54c0,3.24-2.63,5.87-5.87,5.87h-239.3c-3.24,0-5.87-2.63-5.87-5.87v-217.54c0-20.38,7.78-38.96,20.58-52.88,7.23-7.93,16.09-14.34,26.01-18.73,1.9-.85,3.82-1.62,5.79-2.32,8.13-2.84,16.86-4.39,25.94-4.39h94.41c12.92,0,25.12,3.12,35.84,8.66,19.33,9.98,33.95,27.74,39.76,49.11,1.77,6.56,2.72,13.44,2.72,20.55Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "991.93 369.45 1051.55 271.8 1048.09 269.13 988.47 366.78 991.93 369.45"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1141.14 148.19 1108.18 123.19 1126.48 61.98 1163.2 70.04 1141.14 148.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1183.72,56.52l-5.92-1.3c-9.5-2.09-18.89,3.92-20.98,13.42h0l5.92,1.3c9.5,2.09,18.89-3.92,20.98-13.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1183.72,47.93l-5.92-1.3c-9.5-2.09-18.89,3.92-20.98,13.42h0l5.92,1.3c9.5,2.09,18.89-3.92,20.98-13.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1170.37,42.87l-6.03.67c-9.67,1.07-16.63,9.78-15.56,19.45h0l6.03-.67c9.67-1.07,16.63-9.78,15.56-19.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m1174.2,66.78v.93c-.02,1.52-.21,3.08-.55,4.63-2.7,12.19-14.17,20.19-26.3,18.82-.82-.09-1.63-.25-2.45-.42-1.35-.3-2.66-.7-3.89-1.22-10.73-4.33-17.07-15.88-14.51-27.56,2.85-13.01,15.72-21.25,28.75-18.4,2.91.65,5.58,1.79,7.96,3.32l1.25.87.19.13c5.83,4.43,9.41,11.39,9.52,18.87h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m1174.29,96.17c0,.28,0,.57-.04.84-.44,6.78-7.31,12.06-14.03,10.58l-18.57-4.06-.65-14-1.12-24.48,3.46.17,30.86,1.56v.93l.1,28.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1173.92,62.43h-18.52c-7.57-.11-8.07,11.75-17.51,15.87-7.78,3.4-14.48,3.23-17.18,2.97l5.77-19.28c2.86-13.02,15.73-21.27,28.75-18.41,9.63,2.11,16.81,9.76,18.69,18.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1153.05 106.02 1138.69 102.87 1150.77 114.09 1153.05 106.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m1143.42,78.67c-.94,4.27-5.16,6.97-9.43,6.03-4.27-.94-6.97-5.16-6.03-9.43.94-4.27,5.16-6.97,9.43-6.03,4.27.94,6.97,5.16,6.03,9.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1167.99 88.63 1171.61 88.63 1171.61 81.79 1170.32 81.79 1170.32 87.34 1167.99 87.34 1167.99 88.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1166.18,95.7c-4.64,0-7.84-4.4-7.84-4.4h7.84v4.4Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1240.73 375.06 1240.73 293.45 1258.48 368.34 1240.73 375.06"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "877.45 284.33 881.78 381.52 965.48 390.27 946.15 308.78 877.45 284.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m882.25,294.96l35.35,27.21c10.34,7.96,25.17,6.03,33.12-4.31h0c7.96-10.34,6.03-25.17-4.31-33.12l-35.35-27.21c-10.34-7.96-25.17-6.03-33.12,4.31h0c-7.96,10.34-6.03,25.17,4.31,33.12Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1105.98 111.91 1144.1 140.35 1137.48 163.42 1095.58 126.54 1105.98 111.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1149.35 118.87 1142.98 140.94 1159.23 160.99 1162.48 130.02 1149.35 118.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1142.98 140.94 1137.48 163.42 1152.38 173.65 1152.33 376.09 1174.99 411.53 1195.13 379.99 1156.42 172.35 1159.23 160.99 1142.98 140.94"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1274.03,
    y: 0,
    width: 92.92,
    height: 172.79,
    rx: 25.97,
    ry: 25.97,
    transform: "translate(2640.98 172.79) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m1296.9,130.95c.71,5.63,2.64,11.2,5.81,16.33l8.02,12.48,25.89,40.33,40.79,63.54c11.98,19.4,37.4,25.42,56.8,13.41,19.4-11.98,25.39-37.44,13.44-56.87l-38.8-60.4-35.91-55.95c-4.49-7.24-10.84-12.62-18.04-15.87-2.82-1.28-5.74-2.25-8.77-2.85h-.04c-2.71-.57-5.49-.86-8.27-.86-7.42,0-14.9,2-21.68,6.17-14.26,8.84-21.29,24.92-19.25,40.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1310.74,159.76l66.68,103.87c11.98,19.4,37.4,25.42,56.8,13.41,19.4-11.98,25.39-37.44,13.44-56.87l-38.8-60.4h-98.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1410.06 161.61 1393.81 169.08 1418.03 173.69 1410.06 161.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1429.43,194.07l-12.88,9.27-11.92-5.54s8.94-7.45,24.81-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m1390.11,499.82c5.97-97.42,1.72-190.76,1.72-190.76l-36.7-1.81.1-2.89-123.57-4.26s-41.53,71.06-42.87,124.38c-.49,19.41,1.21,45.67,4.28,75.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m1396.14,184.61l-4.3,124.46h-158.51c-13.46,0-24.24-11.15-23.79-24.6l5.95-177.66c.25-7.15,3.15-13.63,7.7-18.44,5.38-5.69,13.07-9.12,21.49-8.83l86.27,2.98c12.14.42,23.15,7.16,29.07,17.78l27.81,49.86c5.86,10.51,8.72,22.42,8.31,34.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m1225.42,87.95c11.91,16.83,28.63,38.94,47.71,59.69,19.54,21.29,41.58,41.15,63.51,52.45,3.85,2.03,7.7,3.74,11.55,5.17,23.61,8.77,39.47-2.28,50.13-20.43l.04-.64c.43-12.02-2.46-23.96-8.31-34.44l-27.81-49.88c-1.89-3.39-4.28-6.35-7.06-8.84-2.67-2.42-5.74-4.42-9.02-5.92h-.04c-2.28-1.03-4.71-1.82-7.2-2.32-1.89-.39-3.78-.61-5.74-.68l-5.74-.21-67.18-2.28-13.34-.5c-1.85-.07-3.64.04-5.38.36,0,0,0-.04-.04,0-.57.07-1.11.18-1.68.32-5.28,1.14-10.02,3.78-13.73,7.49-.25.21-.46.43-.68.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m1195.86,292.69c21.68,6.31,44.29-6.1,50.53-27.74l2.92-35.62,18.44-63.26,5.38-18.43,4.67-15.97c.57-2.03,1-4.03,1.25-6.06.36-2.67.43-5.35.25-7.99-1.11-16.65-12.48-31.66-29.42-36.62-2.78-.82-5.56-1.32-8.34-1.53,0,0,0-.04-.04,0-.68-.04-1.32-.07-1.96-.07-6.2-.21-12.23,1-17.72,3.46-3.03,1.36-5.88,3.07-8.52,5.13-6.45,5.1-11.48,12.19-13.94,20.72l-4.81,16.54-9.31,40.83-17.29,75.91c-6.2,21.68,6.28,44.36,27.92,50.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1239.54,79.39c.11.11.21.25.29.39,6.7,8.95,21.57,27.1,39.47,37.83,8.49,5.1,17.65,8.52,26.92,8.52,30.2,0,32.7-32.8,32.7-43.36-1.89-.39-3.78-.61-5.74-.68l-5.74-.21-67.18-2.28-13.34-.5c-1.85-.07-3.64.04-5.38.36,0,0,0-.04-.04,0-.68-.04-1.32-.07-1.96-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1195.85,292.69c21.68,6.31,44.29-6.1,50.53-27.74l2.92-35.62,18.44-63.26h-82.51l-17.29,75.91c-6.2,21.68,6.28,44.36,27.92,50.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1260.07 166.07 1240.11 166.07 1245.31 183.45 1217.27 206.22 1238.09 212.16 1260.07 166.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1218.4,
    y: 174.85,
    width: 75.72,
    height: 4.07,
    transform: "translate(671.91 1302.94) rotate(-70.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1303.73 104.43 1275.27 81.24 1293.37 27.47 1325.68 35.75 1303.73 104.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1315.57 67.37 1302.95 64.13 1313.31 74.46 1315.57 67.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1281.28 63.38 1311.9 78.86 1304.05 109.41 1275.27 81.24 1281.28 63.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1327.45,30.36l.18,1.47c.07,1.15.03,2.32-.08,3.49-1.09,11.1-10.44,19.38-21.34,19.33-.69.02-1.36-.02-2.06-.09-1.22-.12-2.4-.34-3.56-.67-9.9-2.66-16.71-12.2-15.67-22.76.55-5.53,3.16-10.37,6.98-13.79,3.32-3.03,7.56-4.98,12.21-5.44,1.37-.12,2.79-.13,4.21.01.2.02.41.04.59.09,5.92.72,11.02,3.84,14.38,8.29,2,2.6,3.39,5.69,3.99,9.01.09.35.15.72.17,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1330.62,56.29c.05.46.09.9.07,1.35,0,.02-.02.02-.02.05-.07,5.74-5.39,10.72-11.27,10.15l-16.77-1.64-2.04-12.29-3.55-21.46.2-.02,30.22-2.05.18,1.47,3,24.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1326.75,26.57s-3.46-6.29-17.49,3.71c-3.3,2.35-7.5,13.87-11.76,14.98-7.29,1.89-13.25,3.45-15.65,3.5l3.06-17.61c1.16-11.79,11.63-20.41,23.4-19.25,8.7.86,15.83,6.85,18.44,14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1301.48,43.18c-.38,3.86-3.81,6.69-7.67,6.31-3.86-.38-6.68-3.82-6.3-7.68.38-3.86,3.81-6.69,7.67-6.31,3.86.38,6.68,3.82,6.3,7.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1322.86 51.5 1326.41 51.08 1325.61 44.37 1324.35 44.52 1325 49.97 1322.71 50.24 1322.86 51.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1320.6,58.44l-.23-1.25c-3.31.61-6.29-2.16-6.32-2.18l-.88.92c.14.13,3.46,3.24,7.42,2.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1394.14,192.04h4.07v-20.95c0-5.64-1.61-11.13-4.65-15.87l-30.08-46.91-3.43,2.2,30.08,46.91c2.62,4.09,4.01,8.82,4.01,13.68v20.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1341.97,236.47s-117.7,54.94-121.34,55.95c-25.74,7.18-44.7-6.71-50.82-28.7-2.42-8.72-1.86-17.57,1.07-25.46,4.45-11.96,14.39-21.73,27.64-25.42l128.98-28.29,14.46,51.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1226.88,206.49s9.06,3.83,23.14,9.76c47.88,20.16,153.65,64.68,156.34,65.38,24.73,6.42,42.59-7.19,48.07-28.29,2.16-8.39,1.47-16.82-1.47-24.32-4.46-11.34-14.13-20.51-26.84-23.81l-131.61-34.3h-.02l-4.85-1.26c-27.5-7.19-55.62,9.33-62.75,36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1226.88,206.49s9.06,3.83,23.14,9.76c1.47-5.32,4.07-13.34,8.66-24.2,9-21.3,34.87-21.16,35.8-21.14l-4.85-1.26c-27.5-7.19-55.62,9.33-62.75,36.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1306.05,
    y: 148.7,
    width: 4.07,
    height: 184.53,
    transform: "translate(584.18 1356.81) rotate(-67.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1224.4,
    y: 265.23,
    width: 100.97,
    height: 4.07,
    transform: "translate(7.15 566.63) rotate(-25.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1410.31,203.34l.69-1.1c3.19-5.09,8.63-8.33,14.63-8.7l5.4.77s-5.19-20.13-23.91-28c-29.06-12.22-54.86,20.71-54.86,20.71l58.05,16.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1352.24,
    y: 119.68,
    width: 4.07,
    height: 133.6,
    transform: "translate(832.53 1450.06) rotate(-75.4)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1431.37 157.55 1371.47 268.92 1416.12 268.92 1431.37 157.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "1590.68 144.47 1702.44 288.47 1654.23 318.7 1573.52 232.71 1590.68 144.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1678.95 245.18 1599.87 296.63 1609.2 153.1 1678.95 245.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1605.22 287.48 1602.76 252.95 1630.76 280.6 1605.22 287.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1331.27 499.9 1434.78 367.74 1541.16 450.83 1524.32 472.4 1502.84 499.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "1481.27 499.9 1481.43 467.71 1524.32 472.4 1618.58 482.71 1617.74 499.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m1618.59,482.73l-13.95-213.36,12.9-91.36c2.53-17.71-11.23-33.52-29.09-33.52h-134.65c-3.22,0-6.36.6-9.23,1.74-7.87,2.97-13.98,9.77-15.94,18.37l-4.68,20.71-62.27,275.79,256.91,21.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m1618.58,482.71l-256.91-21.63,38.4-169.98,24.21-107.41h84.31c19.14,0,35.77,13.11,40.28,31.7l.52,6.21.3,3.23,6.36,142.9,56.82,27.71,5.7,87.26Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "1600.18 499.9 1603.8 426.16 1606.99 425.7 1603.36 499.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1614.93 426.89 1369.39 426.89 1370.11 423.71 1614.72 423.71 1614.93 426.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1480.56,
    y: 425.31,
    width: 3.09,
    height: 74.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1481.3,488.86h.8s0-3.09,0-3.09h-.8c-11.31,0-20.52-9.21-20.52-20.52v-39.94s-3.09,0-3.09,0v39.94c0,13.02,10.59,23.61,23.61,23.61Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "1443.98 499.9 1442.55 498.53 1493.69 497.75 1492.95 499.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1514.94,204.05c0,1.78,1.44,3.22,3.22,3.22s3.22-1.44,3.22-3.22-1.44-3.22-3.22-3.22-3.22,1.44-3.22,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1431.74,204.05c0,1.78,1.44,3.22,3.22,3.22s3.22-1.44,3.22-3.22-1.44-3.22-3.22-3.22-3.22,1.44-3.22,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1403.39,334.79l9.9-70.99h112.78s-9.9,70.99-9.9,70.99c-2.38,17.08-18.12,30.98-35.08,30.98h-51.26c-16.96,0-28.82-13.9-26.44-30.98Zm12.67-67.75l-9.45,67.75c-2.13,15.3,8.49,27.74,23.68,27.74h51.26c15.19,0,29.28-12.44,31.41-27.74l9.45-67.75h-106.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1415.71,224.82h133.99s-.29-3.22-.29-3.22h-132.15c-.55,1.08-1.06,2.14-1.54,3.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1532.71 200.05 1517.35 192.44 1541.09 144.47 1560.22 144.47 1532.71 200.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m1423.35,189.55l14.14,2.4,7.08-45.73c-7.87,2.97-13.98,9.77-15.94,18.37l-4.68,20.71-.6,4.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1341.33,218.1h60.27c47.62,0,86.22,53.41,86.22,119.29,0,65.88-38.6,119.29-86.22,119.29h-60.27v-238.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1341.33,
    cy: 337.39,
    rx: 86.22,
    ry: 119.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 1341.33,
    cy: 337.39,
    rx: 54.4,
    ry: 90.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1365.04,373.19l6.36,16.65c-5.44,5.47-11.78,8.61-18.6,8.61-3,0-5.93-.6-8.71-1.77l9.34-24.48c2.08,1.45,4.31,2.25,6.63,2.25,1.72,0,3.39-.44,4.98-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1341.06,343.65c.75,8.42,2.98,15.87,6.15,21.34l-10.4,27.22c-10.96-9.07-18.8-27.12-20.1-48.46l24.36-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1332.21,287.11l11.61,30.41c-1.74,5.18-2.81,11.25-3,17.73l-24.29.1c.39-20.01,6.51-37.6,15.68-48.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1348.88,307.26l-10.02-26.23c4.31-3.02,9-4.69,13.94-4.69,8.73,0,16.72,5.18,22.96,13.79l-5.88,15.41c-2.85-3.31-6.22-5.2-9.82-5.2-4.19,0-8.06,2.56-11.18,6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1379.07,343.48l9.82-.05c-.87,15.27-5.1,28.89-11.42,38.76l-5.83-15.24c3.9-5.59,6.6-13.91,7.43-23.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1379.29,335.08c-.24-7.6-1.67-14.59-3.97-20.27l5.88-15.41c4.67,9.87,7.57,22.21,7.86,35.66l-9.77.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1372.61,337.4c0,2.13-.17,4.16-.48,6.1-.63,3.73-1.81,6.99-3.39,9.48-1.89,3-4.31,4.81-6.99,4.81h-.15c-.07,0-.17,0-.24-.02-2.69-.17-5.13-2.18-6.94-5.37-1.4-2.37-2.44-5.4-3.02-8.81-.34-1.96-.51-4.04-.51-6.19,0-.75.02-1.48.05-2.18.1-1.43.24-2.81.48-4.11.8-4.72,2.49-8.69,4.72-11.2,1.65-1.86,3.56-2.93,5.61-2.93,1.89,0,3.68.92,5.23,2.52,2.25,2.32,4.02,6.1,4.91,10.65v.02c.34,1.57.56,3.22.65,4.96.05.75.07,1.5.07,2.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1345.68,412.28c-1.42.24-2.87.36-4.35.36-24.21,0-43.82-33.7-43.82-75.25,0-41.55,19.61-75.25,43.82-75.25,1.48,0,2.93.12,4.35.36-22.18,3.78-39.47,35.87-39.47,74.89,0,39.02,17.29,71.11,39.47,74.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m1501.72,314.62l120.36-31.72c42.36-13.98,79.15-13.64,87.88,20.59,8.73,34.23-17.07,56.58-49.21,54.31l-161.98-6.26,2.96-36.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "1516.8 353.67 1506.71 313.45 1534.68 305.93 1543.49 353.27 1516.8 353.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m1470.21,292.67h37.68v48.89c0,13.08-10.62,23.7-23.7,23.7h-37.68v-48.89c0-13.08,10.62-23.7,23.7-23.7Z",
    transform: "translate(1566.67 -1181.77) rotate(80.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m1279.99,425.38h44.64v17.63c0,9.24-7.5,16.75-16.75,16.75h-44.64v-17.63c0-9.24,7.5-16.75,16.75-16.75Z",
    transform: "translate(607.02 -739.92) rotate(40.96)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1486.18 171.49 1521.49 144.7 1501.88 79.12 1462.54 87.76 1486.18 171.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1450.76,84.26v1c.02,1.63.22,3.3.59,4.96,2.89,13.06,15.18,21.63,28.18,20.16.87-.1,1.75-.26,2.62-.45,1.44-.33,2.85-.75,4.17-1.3,11.5-4.64,18.29-17.01,15.54-29.52-3.05-13.94-16.85-22.77-30.8-19.72-3.11.69-5.98,1.91-8.53,3.56l-1.34.94-.2.14c-6.25,4.75-10.08,12.2-10.2,20.22h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1450.66,115.76c0,.31,0,.61.04.9.47,7.26,7.83,12.92,15.04,11.33l19.9-4.35.69-15,1.2-26.23-3.7.18-33.06,1.67v1s-.1,30.5-.1,30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1458.45,118.13l.07-1.19c3.16.17,5.59-2.76,5.62-2.79l.93.75c-.11.14-2.84,3.44-6.61,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1451.06,79.6h19.84c8.12-.11,8.65,12.59,18.76,17.01,8.33,3.64,15.52,3.46,18.41,3.18l-6.18-20.66c-3.07-13.95-16.85-22.79-30.81-19.73-10.32,2.26-18.01,10.46-20.02,20.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1456.4,
    cy: 67.68,
    r: 14.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1473.42 126.31 1488.8 122.93 1475.86 134.95 1473.42 126.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1483.73,97c1,4.57,5.53,7.47,10.1,6.46,4.57-1,7.47-5.53,6.46-10.1-1-4.57-5.53-7.47-10.1-6.46-4.57,1-7.47,5.53-6.46,10.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1457.42 107.67 1453.54 107.67 1453.54 100.34 1454.92 100.34 1454.92 106.29 1457.42 106.29 1457.42 107.67"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1112.91,499.9l-6.7-8.66s-.02-.03-.07-.06l-2.43-3.17,9.04-7,38.8-30.11,2.26,2.92,10.47,13.53s8.41,10.86,13.44,17.37l3.42,4.43,7.79,10.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m1060.36,499.84l-61.72-88.81c-17.13-24.66-11.04-58.53,13.62-75.67h0c24.66-17.14,58.53-11.04,75.67,13.62l80.57,115.93-50.26,34.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "1064.65 499.82 1151.03 439.79 1159.25 451.61 1089.77 499.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1036.34,
    y: 441.04,
    width: 108.73,
    height: 14.4,
    transform: "translate(-60.75 702.61) rotate(-34.8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 971.87,
    y: 85.77,
    width: 54.38,
    height: 9.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m922.97,94.63h103.28v34.82c0,9.08-7.37,16.45-16.45,16.45h-70.39c-9.08,0-16.45-7.37-16.45-16.45v-34.82h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "849.93 499.83 846.32 407.95 1008.7 407.95 1004.28 499.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m845.17,499.83V192.64c0-27.66,22.43-50.09,50.09-50.09h145.09c27.66,0,50.09,22.43,50.09,50.09v307.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "1000.46 499.84 1000.46 165.02 1031.46 165.02 1031.46 499.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 884.95,
    y: 436.27,
    width: 205.49,
    height: 22.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 884.95,
    y: 247.02,
    width: 205.49,
    height: 22.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "880.71 491.44 880.71 271.58 922.97 279.47 880.71 491.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "981.84 165.02 939.59 149.96 957.38 78.22 1000.25 85.52 981.84 165.02"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 984.91,
    cy: 82.91,
    r: 27.93,
    transform: "translate(133.49 584.92) rotate(-35.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m998.86,129.08l-21.68-3.69-4.15-44.36,39.76.11,1.72,33.98c.51,8.26-7.44,15.36-15.64,13.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1013.36,76.09l-22.12,1.05c-9.14.31-9.06,14.64-20.21,20.15-9.19,4.54-16.6,6.21-19.87,6.05l5.17-25.08c2.7-15.88,17.76-26.57,33.63-23.86,11.74,2,20.48,10.04,23.4,21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m981.49,95.22c-.85,4.98-5.58,8.34-10.56,7.49-4.98-.85-8.34-5.58-7.49-10.56.85-4.98,5.58-8.34,10.56-7.49,4.98.85,8.34,5.58,7.49,10.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m976.9,83.29l-1.89,39.57s6.17,9.43,17.12,12.35c10.95,2.92,23.9-1.71,25.67-5.81,1.77-4.1-3.78-24.16-3.78-24.16,0,0-10.11.03-14.12,1.69-4.01,1.66-5.44,6.01-5.44,6.01,0,0-7-.15-8.53-8.43-1.54-8.28-1.71-25.71-1.71-25.71l-7.32,4.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1012.94 104.66 1008.78 104.85 1008.71 103.38 1011.39 103.25 1011.15 98.15 1012.63 98.08 1012.94 104.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1001.35,112.92c3.53,3.09,8.71,1.95,8.93,1.9l-.33-1.44s-4.67,1.02-7.62-1.57l-.97,1.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m965.3,68.61h-8.49c0-20.92,12.32-37.93,27.46-37.93v8.49c-10.28,0-18.97,13.48-18.97,29.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 946.13,
    y: 85.77,
    width: 69.42,
    height: 4.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m962.38,39.08h34.11c11.45,0,20.74,9.29,20.74,20.74v22.24h-75.59v-22.24c0-11.45,9.29-20.74,20.74-20.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 959.67,
    y: 82.05,
    width: 71.89,
    height: 3.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m922.97,94.61h27.57c5.56,0,10.06-4.5,10.06-10.06v-2.5h-25.07c-6.93,0-12.56,5.62-12.56,12.56h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 941.64,
    y: 76.24,
    width: 39.21,
    height: 5.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m987.29,54.2h19.46c6.8,0,12.33,5.52,12.33,12.33v15.52h-44.12v-15.52c0-6.8,5.52-12.33,12.33-12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m805.73,393.92h0c-26.7-13.73-37.21-46.51-23.48-73.21l68-132.21c13.73-26.7,46.51-37.21,73.21-23.48h0c26.7,13.73,37.21,46.51,23.48,73.21l-68,132.21c-13.73,26.7-46.51,37.21-73.21,23.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m819.6,499.84l-.83-16.17s0-.04-.02-.09l-.18-3.99,11.42-.59,49.05-2.58.19,3.69.88,17.09s.05,1.01.14,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m806.6,302.04h47.96c16.77,0,30.38,13.61,30.38,30.38v165.16h-108.73v-165.16c0-16.77,13.61-30.38,30.38-30.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 776.22,
    y: 466.98,
    width: 108.73,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 776.22,
    y: 432.3,
    width: 108.73,
    height: 14.4
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 935.44,
    y: 138.43,
    width: 77.4,
    height: 28.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1000.46,
    y: 247.02,
    width: 31,
    height: 22.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1000.46,
    y: 436.27,
    width: 31,
    height: 22.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m796.8,292.41l-1.43,2.76c13.77,9.21,23.05,26.37,23.05,45.98,0,27.77-18.58,50.63-42.19,53.05v3.13c25.32-2.42,45.3-26.68,45.3-56.19,0-20.82-9.96-39.03-24.73-48.74Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "1090.44 352.6 1090.44 499.82 1091.72 499.82 1106.77 376.09 1090.44 352.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m955.83,499.83c-5.67-57.24-13.62-116.99-24.43-157.95h-147.08v157.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m603.82,499.83c12.66-57.2,30.38-116.88,54.38-157.76h147.08s-21.65,157.76-21.65,157.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m674.82,148.11s-46.16,16.91-70.03,92.23c-15.51,48.93-18.12,114.73-18.12,114.73l41.01,1.48,47.15-208.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m956.44,499.82l-20.98-324.01c-1.44-21.8-19.55-38.74-41.39-38.7l-178.01.22h-5.78c-8.29.04-16.24,1.62-23.53,4.57-20.66,8.17-36.2,26.88-39.59,50.04l-45.06,307.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m686.56,204.56l28.91.59.59-67.83h-5.78c-8.29.04-16.24,1.62-23.53,4.57l-.18,62.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "848.65 211.58 822.71 198.75 843.44 137.1 875.74 137.1 848.65 211.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m601.19,499.84l9.6-84.52.44-3.97,4.65-40.84,25.7-14.58,30.07-138.37.85-3.97,4.33-19.9c1.39-6.4,7.03-10.94,13.57-10.94h143.29c8.56,0,15.97,5.98,17.78,14.34l3.58,16.51.87,3.97,29.18,134.57,63.82,29.73,1.93,29.48.26,3.97,5.51,84.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 659.73,
    y: 294.99,
    width: 218.66,
    height: 123.11,
    transform: "translate(1538.11 713.09) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 705.13,
    cy: 285.99,
    r: 77.43,
    transform: "translate(-21.08 58.81) rotate(-4.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m670.94,416.8l237.73-74.11-39.24-125.88-237.73,74.11c-34.76,10.84-54.16,47.8-43.32,82.56h0c10.84,34.76,47.8,54.16,82.56,43.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "659.73 281.12 763.36 406.28 829.4 371.28 659.73 281.12"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 885.41,
    cy: 274.93,
    rx: 69.23,
    ry: 82.7,
    transform: "translate(-41.7 275.97) rotate(-17.31)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m964.04,355.06c-18.43,33.59-50.07,65.26-83.66,46.84h0c-33.59-18.43-45.88-60.59-27.45-94.18l39.49-170.68c106.33,2.43,71.62,218.03,71.62,218.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m861.6,409.54l-201.87-128.42s51.28-58.62,92.12-54.29l176.48,61.09c33.59,18.43,45.88,60.59,27.45,94.18h0c-18.43,33.59-60.59,45.88-94.18,27.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "866.96 266.67 790.82 241.31 814.87 233.81 866.96 266.67"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m761.04,77.95c-.17,15.91,12.6,28.95,28.51,29.11,15.91.17,28.95-12.6,29.11-28.51.17-15.91-12.6-28.95-28.51-29.11-15.91-.17-28.95,12.6-29.11,28.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "765.75 164.54 818.56 143.49 792.66 53.44 738.69 64.71 765.75 164.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m726.1,137.19h114.65s-36.28,42.58-75.87,42.58c-39.59,0-38.79-42.58-38.79-42.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 736.4,
    cy: 46.77,
    r: 28.81,
    transform: "translate(81.75 387.21) rotate(-31.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 758,
    cy: 60.68,
    r: 35.4,
    transform: "translate(23.04 255.8) rotate(-19.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m742.5,119.82l27.29-5.7,3.17-56.39-50.36,2.01-.58,43.12c-.26,10.49,10.15,19.1,20.47,16.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m721.64,53.37l28.07.29c11.6-.04,12.17,18.12,26.56,24.58,11.85,5.32,22.12,5.17,26.25,4.82l-8.53-29.61c-4.17-19.98-23.74-32.82-43.73-28.65-14.77,3.08-25.47,13.68-28.63,28.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m762.91,76.1c1.31,6.28,7.46,10.3,13.73,8.99,6.28-1.31,10.3-7.46,8.99-13.73-1.31-6.28-7.46-10.3-13.73-8.99-6.28,1.31-10.3,7.46-8.99,13.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m768.17,60.78l4.25,50.04s-7.75,13.74-21.47,17.95c-13.73,4.21-33.58-.42-36.01-5.53-2.43-5.11,7.24-32.92,7.24-32.92,0,0,12.81-.44,17.96,1.48,5.15,1.92,7.18,7.36,7.18,7.36,0,0,8.86-.52,10.42-11.08,1.56-10.56.96-32.65.96-32.65l9.49,5.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "723.51 89.54 728.8 89.59 728.82 87.72 725.41 87.68 725.48 81.21 723.6 81.19 723.51 89.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m727.41,104.45c5.94.32,10.21-4.86,10.39-5.08l-1.46-1.18s-3.86,4.66-8.83,4.39l-.1,1.87Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m254.03,499.83c4.25-68.34,3.34-134.73,3.34-134.73l-122.55-1.79-23.89,136.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m57.64,499.82c.12-4.17.32-8.25.59-12.25,5.41-83.64,38.59-125.91,38.59-125.91h123.77l8.69,138.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m91.9,499.82c2.57-45.56,7.4-91.67,14.48-138.17.99-6.51,2.02-13.03,3.1-19.54.56-3.42,5.64-3.36,5.09,0-1.07,6.51-2.11,13.03-3.1,19.54-7.07,46.49-11.87,92.61-14.39,138.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m257.38,240.46v124.64H94.38l-20.43-196.23c0-7.17,2.68-13.74,7.08-18.69,5.19-5.9,12.77-9.58,21.2-9.58h86.39c12.15,0,23.41,6.34,29.69,16.78l29.54,48.92c.06.09.09.15.15.24,6.13,10.26,9.38,21.97,9.38,33.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m161.31,212.22l58.64,84.71,33.58,48.5c12.93,18.79,38.67,23.54,57.47,10.59,18.79-12.96,23.54-38.69,10.61-57.51l-82.3-118.87-9.94-14.35c-5.09-7.41-12.18-12.63-20.04-15.45-12.09-4.33-26.01-2.99-37.41,4.87-18.79,12.96-23.54,38.69-10.61,57.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m257.38,240.46v.65c-10.05,18.52-25.56,30.1-49.48,22.14-15.3-5.07-31.05-14.89-46.29-27.04-32.08-25.51-61.92-61.45-80.58-86.04,5.19-5.9,12.77-9.58,21.2-9.58h86.39c12.15,0,23.41,6.34,29.69,16.78l29.54,48.92c.06.09.09.15.15.24,6.13,10.26,9.38,21.97,9.38,33.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m200.93,103.92l-24.55,60.65c-8.77-7.43-28.75-23.92-28.75-23.92l20.24-47.9,33.05,11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m211.4,102.02l-.17,1.54c-.2,1.19-.52,2.37-.9,3.54-3.73,11.05-15.22,17.27-26.31,14.65-.71-.15-1.38-.34-2.08-.58-1.21-.41-2.37-.91-3.46-1.52-9.45-5.05-14.14-16.38-10.58-26.89,1.86-5.5,5.67-9.82,10.37-12.4,4.09-2.3,8.88-3.29,13.72-2.66,1.42.2,2.88.53,4.29,1.01.2.07.4.14.58.23,5.86,2.14,10.32,6.52,12.69,11.84,1.43,3.12,2.11,6.6,1.93,10.12,0,.37-.01.77-.08,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m208.5,129.17c-.05.48-.13.94-.25,1.39,0,.02-.03.02-.03.04-1.43,5.83-8.02,9.65-13.88,7.68l-16.7-5.64.83-13.01,1.45-22.7.21.02,31.26,5.05-.17,1.54-2.73,25.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 149.54,
    cy: 70.07,
    r: 34.17,
    transform: "translate(-1.58 136.66) rotate(-48.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m211.59,97.99s-15.81,11.64-34.21,12.12c-7.87.21-14.31.38-16.77-.14l7.28-17.21c3.96-11.73,16.67-18.04,28.39-14.08,8.66,2.93,14.51,10.72,15.31,19.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "187.9 136.11 174.99 131.74 184.98 143.32 187.9 136.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m181.92,108.93c-1.3,3.85-5.47,5.91-9.31,4.61-3.84-1.3-5.9-5.47-4.6-9.32,1.3-3.85,5.47-5.91,9.31-4.61,3.84,1.3,5.9,5.47,4.6,9.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "205.45 122.88 201.73 122.47 201.88 121.14 204.27 121.41 204.9 115.7 206.22 115.85 205.45 122.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m197.87,128.26c-4.14.78-7.63-2.46-7.77-2.6l.91-.97s3.15,2.91,6.61,2.26l.25,1.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m142.42,201.32l-40.04,94.93-22.92,54.35c-8.81,21.04-33.02,30.97-54.08,22.14-21.04-8.83-30.97-33.05-22.18-54.11l56.19-133.21,6.79-16.08c3.46-8.29,9.33-14.86,16.45-19.23,10.95-6.72,24.85-8.25,37.62-2.9,21.04,8.83,30.97,33.05,22.18,54.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "183.52 212.95 172.84 222.01 103.84 140.6 122.18 140.6 183.52 212.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m257.38,240.46v124.64h-122.13l26.36-128.88,6.07-29.69h80.32c5.13,8.58,8.26,18.19,9.11,28.13.18,1.92.27,3.86.27,5.81Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "121.17 499.82 121.17 363.32 257.45 363.32 257.45 499.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "89.69 326.35 115.22 265.81 123.78 282.86 89.69 326.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m180.65,216.52c0,1.83-1.49,3.32-3.32,3.32s-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32,3.32,1.49,3.32,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m257.38,240.55v-.09c0-1.95-.09-3.89-.27-5.81h-73.51v67.99c0,23.74,19.31,43.05,43.08,43.05h30.69v-5.9h-30.69c-20.49,0-37.18-16.66-37.18-37.15v-62.1h67.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m224.61,300.9c-81.38,39.62-133.49,100.21-119.28,129.39,4.47,9.18,9.58,17.37,24.72,19.3,1.96.25,3.73,0,5.26-.75l260.83-127c1.53-.75,2.83-1.98,3.84-3.68,7.82-13.11,4.52-22.18.05-31.36-14.21-29.19-94.04-25.53-175.42,14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m388.64,294.58c-.61-.32-63.86-31.87-166.88,26.36-103.46,58.47-107.3,98.79-107.33,99.19l-9.76-.65c.12-1.85,4.27-46.01,112.28-107.05,108.03-61.05,173.51-27.94,176.24-26.5l-4.56,8.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m133.77,400.33c4.33.82,11.43-17.48,15.86-40.88.75-3.96,1.36-7.79,1.86-11.46-7.06,6-13.46,12.05-19.12,18.03-2.77,18.97-2.32,33.61,1.4,34.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m170.49,375.16c4.33.82,11.43-17.48,15.86-40.88.88-4.62,1.56-9.07,2.1-13.28-6.33,3.99-12.37,8.08-18.12,12.23-4.07,22.53-4.05,41.13.16,41.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m209.35,354.42c4.33.82,11.43-17.48,15.86-40.88.92-4.88,1.64-9.56,2.19-13.97-.93.44-1.86.89-2.79,1.34-5,2.43-9.88,4.94-14.65,7.52-.14.71-.29,1.42-.43,2.14-4.43,23.4-4.52,43.03-.19,43.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m248.93,335.15c4.33.82,11.43-17.48,15.86-40.88.7-3.71,1.29-7.32,1.77-10.78-5.66,1.95-11.39,4.09-17.16,6.41-.09.46-.19.92-.28,1.39-4.43,23.4-4.52,43.03-.19,43.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m290.67,320.29c4.33.82,11.43-17.48,15.86-40.88.47-2.47.87-4.87,1.23-7.23-5.48,1.1-11.1,2.4-16.84,3.9-.02.12-.05.24-.07.36-4.43,23.4-4.52,43.03-.19,43.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m333.83,308.38c4.32.82,11.4-17.42,15.84-40.76-5.17,0-10.62.25-16.33.77-3.73,21.65-3.6,39.22.49,40Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m394.01,279.17c.07.06.15.13.23.19-.07-.06-.15-.13-.23-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m395.93,281c.15.15.3.31.44.47-.14-.16-.29-.31-.44-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m396.91,282.07c.15.17.29.34.43.52-.14-.17-.28-.35-.43-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m394.9,279.98c.15.14.3.28.44.42-.14-.14-.29-.28-.44-.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "404.61 304.89 404.61 304.89 404.61 304.9 404.61 304.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m403.57,295.5c.03.09.05.19.07.28-.05-.2-.11-.39-.17-.59.03.1.07.2.1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m402.91,293.47s.01.03.02.05c-.09-.27-.2-.53-.3-.8.01.04.03.07.04.11.08.21.16.43.24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.55,300.44s0,.02,0,.04c-.03-.28-.06-.55-.1-.83,0,.01,0,.03,0,.04.03.25.06.5.09.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.21,298.2s.01.05.02.08c-.05-.25-.09-.51-.15-.76,0,.01,0,.02,0,.04.05.21.08.43.12.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m402.13,291.43s.02.05.03.07c-.11-.28-.23-.56-.35-.84,0,.02.02.05.03.07.1.23.19.46.29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m400.23,287.23c-.07-.14-.13-.28-.2-.42-.19-.4-.4-.78-.62-1.17.22.38.42.77.62,1.16.07.14.13.28.2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m401.22,289.34s.04.08.05.12c-.12-.26-.23-.52-.35-.77,0,.02.02.04.02.05.09.2.18.4.27.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.68,302.65s0,0,0,.01c0-.25-.02-.5-.03-.75,0,.01,0,.03,0,.04,0,.23.03.46.03.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m400.95,288.74s-.02-.04-.02-.05c-.23-.49-.46-.98-.69-1.46-.07-.14-.13-.28-.2-.42.31.65.62,1.29.92,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m402.67,292.83s-.03-.07-.04-.11c-.15-.41-.31-.81-.47-1.21,0-.02-.02-.05-.03-.07.19.46.37.93.54,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m400.03,286.8c-.19-.39-.4-.78-.62-1.16-.02-.03-.03-.07-.05-.1.24.41.46.83.67,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m403.57,295.5c-.03-.1-.07-.2-.1-.3-.17-.56-.35-1.12-.55-1.68,0-.02-.01-.03-.02-.05.24.67.47,1.35.66,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m401.84,290.74s-.02-.05-.03-.07c-.17-.4-.35-.81-.53-1.21-.02-.04-.04-.08-.05-.12.21.46.42.93.61,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.68,302.66s0,0,0-.01c0,.74,0,1.48-.07,2.24h0c.06-.76.08-1.5.07-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.46,299.68s0-.03,0-.04c-.06-.46-.14-.91-.22-1.36,0-.03-.01-.05-.02-.08.09.49.18.98.24,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.65,301.95s0-.03,0-.04c-.02-.48-.05-.96-.1-1.44,0-.01,0-.02,0-.04.05.5.08,1.01.11,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.09,297.56s0-.02,0-.04c-.13-.58-.27-1.16-.44-1.74-.03-.09-.05-.19-.07-.28.2.68.36,1.36.51,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m398.62,284.34c.16.25.32.5.47.76-.15-.25-.31-.51-.47-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m397.8,283.19c.15.2.29.4.43.6-.14-.2-.28-.4-.43-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m103.24,423.19c.01.11.04.23.05.34h0c-.02-.11-.04-.23-.05-.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m399.09,285.1c-.05-.08-.1-.16-.15-.23.05.08.1.16.15.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m106.51,432.64c-.09-.17-.18-.34-.27-.52.09.17.18.34.27.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m104.66,428.75h0c-.03-.09-.06-.18-.1-.27.03.09.06.18.1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m103.09,417.25c0,.08-.01.16-.02.25h0c0-.08.01-.16.02-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m105.34,430.3s.01.03.02.04c0-.01-.01-.03-.02-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m398.23,283.78c-.14-.2-.28-.4-.43-.6h0c.15.2.29.4.43.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m103.28,415.35c0,.05-.01.11-.02.16h0c0-.05.01-.1.02-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m107.53,434.53c-.11-.2-.23-.4-.34-.6.11.2.22.4.34.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m396.37,281.46c-.14-.16-.29-.31-.44-.47h0c.15.15.3.31.44.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m397.33,282.59c-.14-.17-.28-.35-.43-.52h0c.15.17.29.34.43.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m394.24,279.36c-.07-.06-.15-.13-.23-.19,0,0-.01-.01-.02-.02.08.07.17.14.25.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m394.9,279.98h0c.07.06.14.13.21.2-.07-.07-.14-.13-.21-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m103.03,420.47s0-.09,0-.13c0,.04,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m128.18,449.3c-.17-.03-.36-.05-.53-.08.17.03.36.05.53.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m126.22,448.91c-.32-.07-.64-.14-.94-.22.31.08.63.15.94.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m124.05,448.35c-.32-.1-.65-.19-.96-.29.31.1.63.2.96.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m121.99,447.67c-.31-.12-.62-.24-.92-.36.3.12.61.25.92.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m403.11,311.61c-.17.49-.36.98-.57,1.48.21-.5.39-.99.57-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m401.1,316.15c-.2.37-.41.75-.63,1.13.21-.38.43-.76.63-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m108.58,436.31c-.12-.2-.25-.4-.37-.6.12.2.24.4.37.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m402.14,314.01c-.16.37-.34.74-.52,1.12.18-.38.36-.75.52-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m110.9,439.63c-.13-.16-.25-.33-.37-.49.12.16.25.33.37.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m109.7,438.01c-.13-.19-.26-.38-.38-.57.13.19.25.38.38.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m112.21,441.17c-.1-.11-.19-.22-.29-.33.1.11.19.22.29.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m120.08,446.89c-.3-.14-.59-.29-.88-.43.29.15.58.29.88.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m118.32,446c-.31-.17-.61-.36-.9-.54.3.18.59.37.9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m115.34,444.05c.29.22.59.43.9.64-.32-.22-.64-.44-.94-.68.02.01.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m103.53,424.91c.01.06.02.11.04.17-.01-.06-.02-.11-.04-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.09,297.56c.05.21.08.43.12.64-.04-.21-.08-.43-.12-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m403.57,295.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.65,301.95c0,.23.03.46.03.7,0-.23-.02-.46-.03-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m403.38,310.84c.17-.52.33-1.04.46-1.55-.13.51-.29,1.03-.46,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.61,304.9s0,0,0,0c-.05.6-.13,1.2-.23,1.81.1-.61.18-1.21.23-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m402.67,292.83c.08.21.16.43.24.64-.08-.21-.16-.43-.24-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.28,307.31c-.08.42-.17.85-.27,1.29.1-.43.19-.86.27-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404.46,299.68c.03.25.06.5.09.75-.03-.25-.06-.5-.09-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m401.84,290.74c.1.23.19.46.29.7-.1-.23-.19-.46-.29-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m400.95,288.74c.09.2.18.4.27.6-.09-.2-.18-.4-.27-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m404,308.6c.1-.43.19-.86.27-1.29.04-.2.08-.41.11-.61.1-.61.18-1.22.23-1.81.06-.76.08-1.51.07-2.24,0-.23-.02-.46-.03-.7-.02-.51-.05-1.02-.11-1.52-.03-.25-.06-.5-.09-.75-.07-.5-.15-.99-.24-1.48-.04-.21-.08-.43-.12-.64-.15-.69-.32-1.38-.51-2.05h0c-.2-.69-.43-1.36-.66-2.04-.08-.21-.16-.43-.24-.64-.17-.47-.35-.93-.54-1.4-.1-.23-.19-.46-.29-.7-.2-.47-.4-.93-.61-1.4-.09-.2-.18-.4-.27-.6-.3-.65-.61-1.29-.92-1.94-.21-.43-.43-.85-.67-1.26-.09-.15-.18-.29-.27-.44-.05-.08-.1-.16-.15-.24-.11-.18-.21-.35-.33-.52-.12-.19-.26-.37-.39-.56-.14-.2-.28-.4-.43-.6-.15-.2-.31-.4-.47-.6-.14-.17-.28-.35-.43-.52-.17-.2-.35-.41-.53-.61-.14-.16-.29-.31-.44-.47-.19-.2-.39-.41-.59-.6-.08-.07-.15-.15-.23-.22-.07-.07-.14-.13-.21-.2-.22-.2-.43-.41-.66-.61-.08-.07-.17-.14-.25-.21-.28-.24-.57-.48-.86-.72-2.24,21.42-10.58,25-133.81,85-123.22,60-128.39,62.99-156.03,51.91,0,.05-.01.11-.02.16-.07.59-.13,1.17-.17,1.74,0,.08-.01.16-.02.25-.06.96-.08,1.91-.05,2.84,0,.04,0,.09,0,.13.03.92.1,1.83.21,2.72.02.12.04.23.05.34.07.46.15.92.24,1.38.01.06.02.11.04.17.02.11.05.22.07.33.09.4.19.8.3,1.19.05.17.1.35.15.52.12.4.26.79.4,1.18.02.06.04.12.07.18.03.09.06.18.1.27.21.53.43,1.05.68,1.56,0,.01.01.03.02.04.29.6.59,1.19.89,1.78.09.17.18.34.27.52.23.43.45.87.69,1.29.11.2.22.4.34.6.22.4.45.79.68,1.18.12.2.24.4.37.6.24.38.48.76.73,1.14.13.19.25.38.38.57.27.38.55.76.83,1.13.12.16.25.33.37.49.33.41.67.81,1.02,1.21.1.11.19.22.29.33.93,1.01,1.95,1.96,3.08,2.84.3.23.62.46.94.68.38.26.77.52,1.18.77.3.18.59.37.9.54.28.16.59.3.88.45.29.15.58.29.88.43.32.15.66.29.99.42.3.12.61.25.92.36.36.13.72.26,1.1.38.31.1.63.2.96.29.4.12.81.24,1.23.34.31.08.63.15.94.22.47.11.94.21,1.43.3.17.03.36.05.53.08.61.1,1.22.21,1.87.29,1.96.26,3.73,0,5.26-.75l260.83-127c1.54-.75,2.83-1.97,3.84-3.68.18-.3.33-.59.5-.89.21-.38.43-.76.63-1.13.18-.34.35-.68.51-1.02.18-.38.36-.75.52-1.12.14-.31.28-.61.4-.92.21-.5.4-.99.57-1.48.09-.26.18-.52.27-.77.17-.52.33-1.04.46-1.55.06-.23.11-.46.17-.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m223.82,407.72l-43.6,32.39c-3.66,2.72-8.91,1.75-11.32-2.24-.26-.42-.46-.85-.62-1.3-.64-1.78-.56-3.72.12-5.48.56-1.43,1.51-2.73,2.8-3.69,1.54-1.15,1.31-3.53-.44-4.34l-26.42-12.38s-.03-.01-.07-.02l-2.89-1.37,3.89-8.3,16.68-35.7,2.68,1.26,12.43,5.83s9.98,4.67,15.95,7.48l4.06,1.91,9.24,4.33c20.94,9.5,20.74,19.21,17.5,21.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m164.9,366.68l-16.27,34.83-4.28,9.17s-.03-.01-.07-.02c-.53-.13-4.51-1.04-10.74-2.55-24.54-5.91-84.03-20.74-104.92-30.51-21.83-10.24-26.64-30.9-17.95-49.51,4.35-9.32,12.09-16,21.06-19.24,8.93-3.22,19.11-3.04,28.4,1.31l18.33,9.89s.03.01.05.02l9.16,4.95,10.37,5.59,66.6,35.93.26.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m350.44,360.66l-37.15,13.65c-7.2,2.65-15.18-1.05-17.83-8.25h0c-2.65-7.2,1.05-15.18,8.25-17.83l37.15-13.65c7.2-2.65,15.18,1.05,17.83,8.25h0c2.65,7.2-1.05,15.18-8.25,17.83Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVermittlungPeople);
export default __webpack_public_path__ + "static/media/vermittlung-people.92cd19dcc2942073c1319a02eee43fa7.svg";
export { ForwardRef as ReactComponent };